import { l as logger } from "../../../../../chunks/logger.js";
import { g as getMongo } from "../../../../../chunks/mongo.js";
const load = async ({ params, depends }) => {
  depends("app:users");
  const mongo = await getMongo();
  const client = mongo.getClient(params.server);
  const admin = client.db("admin");
  const usersPromise = (async () => {
    try {
      const result = await admin.command({ usersInfo: { forAllDBs: true } });
      const users = result.users ?? [];
      const usersWithPrivs = await Promise.all(
        users.map(async (u) => {
          try {
            const info = await admin.command({
              usersInfo: { user: u.user, db: u.db },
              showPrivileges: true
            });
            const detail = (info.users ?? [])[0] ?? {};
            return { ...u, ...detail };
          } catch (err) {
            logger.error(`Error getting privileges for user ${u.user}:`, err);
            return u;
          }
        })
      );
      return { data: JSON.parse(JSON.stringify(usersWithPrivs)), error: null };
    } catch (err) {
      logger.error(`Error getting users for server ${params.server}:`, err);
      return {
        data: [],
        error: `Failed to list users: ${err instanceof Error ? err.message : String(err)}`
      };
    }
  })();
  const rolesPromise = (async () => {
    try {
      const result = await admin.command({
        rolesInfo: 1,
        showBuiltinRoles: true,
        showPrivileges: true
      });
      return { data: JSON.parse(JSON.stringify(result.roles ?? [])), error: null };
    } catch (err) {
      logger.error(`Error getting roles for server ${params.server}:`, err);
      return {
        data: [],
        error: `Failed to list roles: ${err instanceof Error ? err.message : String(err)}`
      };
    }
  })();
  const databasesPromise = (async () => {
    try {
      const results = await client.db("test").admin().listDatabases();
      return {
        data: mongo.filterDatabases(results.databases).map((d) => d.name),
        error: null
      };
    } catch (err) {
      logger.error(`Error getting databases for server ${params.server}:`, err);
      return { data: [], error: null };
    }
  })();
  return {
    server: params.server,
    users: usersPromise,
    roles: rolesPromise,
    databases: databasesPromise
  };
};
export {
  load
};
